// Angular imports
import { Component, Input, Output, EventEmitter } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// Model import
import { UserNameDisplayResultDto } from '../../../../_models/user-name-display-result-dto';
import { WFEConflictDataResultDto } from '../../../_models/workflow-supervisor/wfe-conflict-data-result-dto';

@Component({
    selector: 'app-workflow-supervisor-conflicts',
    templateUrl: './workflow-supervisor-conflicts.component.html',
    styleUrls: ['./workflow-supervisor-conflicts.component.scss']
})
export class WorkflowSupervisorConflictsComponent {
    @Input() conflictField: WFEConflictDataResultDto;
    @Input() scannedBy: UserNameDisplayResultDto;
    @Input() verifiedBy: UserNameDisplayResultDto;
    @Input() communityId: number;

    @Output() onConflictResolve = new EventEmitter<any>();
    @Output() onClose = new EventEmitter();

    iconClose = IconConstants.CLOSE;

    onCloseConflict(): void {
        this.onClose.emit();
    }

    onScannedInfoClick(): void {
        const scannedInfo = {
            fieldName: this.conflictField.fieldName,
            value: this.conflictField.scannedStepValue.value
        };
        this.onConflictResolve.emit(scannedInfo);
    }

    onVerifyInfoClick(): void {
        const verifyInfo = {
            fieldName: this.conflictField.fieldName,
            value: this.conflictField.verifyStepValue.value
        };
        this.onConflictResolve.emit(verifyInfo);
    }
}
